import * as React from 'react'

import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns'
import { GridFilterCellProps } from '@progress/kendo-react-grid'
import { Button } from '@progress/kendo-react-buttons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faFilterSlash } from '@fortawesome/pro-regular-svg-icons'

interface DropdownFilterCellProps extends GridFilterCellProps {
    defaultItem: string,
    data: string[]
}

export const DropdownFilterCell = (props: DropdownFilterCellProps) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let hasValue: any = (value: string) => Boolean(value && value !== props.defaultItem)

    const onChange = (event: DropDownListChangeEvent) => {
        hasValue = hasValue(event.target.value)
        props.onChange({
            value: hasValue ? event.target.value : '',
            operator: hasValue ? 'eq' : '',
            syntheticEvent: event.syntheticEvent
        })
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClearButtonClick = (event: any) => {
        event.preventDefault()
        props.onChange({
            value: '',
            operator: '',
            syntheticEvent: event
        })
    }
    return (
        <div className='k-filtercell'>
            <DropDownList
                data={props.data}
                onChange={onChange}
                value={props.value || props.defaultItem}
                defaultItem={props.defaultItem}
            />
            <Button
                title='Clear'
                disabled={!hasValue(props.value)}
                onClick={onClearButtonClick}
            >
                <FontAwesomeIcon icon={faFilterSlash} />
            </Button>
        </div>
    )
}